//Action type constants
export const lsRequestActions = {
  CHECK_DUPLICATE: 'CHECK_DUPLICATE',
  CHECK_LS_IS_LOADING: 'CHECK_LS_IS_LOADING',
  CLEAR_LS_REQUEST_ARRAY: 'CLEAR_LS_REQUEST_ARRAY',
  CLICKED_LS_REQUEST: 'CLICKED_LS_REQUEST',
  CREATE_NEW_LS_REQUEST_STATUS: 'CREATE_NEW_LS_REQUEST_STATUS',
  CREATE_NEW_LS_REQUEST: 'CREATE_NEW_LS_REQUEST',
  DELETE_FILE: 'DELETE_FILE',
  EXPORT_ALL_LS_REQUESTS: 'EXPORT_ALL_LS_REQUESTS',
  EXPORTING: 'EXPORTING',
  GET_BILL_HISTORY: 'GET_BILL_HISTORY',
  GET_DUPLICATE_LS_REQUEST: 'GET_DUPLICATE_LS_REQUEST',
  GET_LS_REQUEST_HISTORY: 'GET_LS_REQUEST_HISTORY',
  GET_NEW_CREATED_LS_NUMBER: 'GET_NEW_CREATED_LS_NUMBER',
  IS_DUPLICATE_LS_LOADING: 'IS_DUPLICATE_LS_LOADING',
  LOAD_LS_REQUESTS: 'LOAD_LS_REQUESTS',
  LOAD_LS_REQUEST_STATUS_APPROVAL_LIST: 'LOAD_LS_REQUEST_STATUS_APPROVAL_LIST',
  OPEN_OR_CLOSE_LS_REQUEST_SERVICE_POPUP:
    'OPEN_OR_CLOSE_LS_REQUEST_SERVICE_POPUP',
  REQUEST_ACTIVATION: 'REQUEST_ACTIVATION',
  SAVE_ALL_HISTORY_LIST: 'SAVE_ALL_HISTORY_LIST',
  SAVE_CURRENT_LS_REQUEST: 'SAVE_CURRENT_LS_REQUEST',
  SAVE_ERROR_MESSAGE: 'SAVE_ERROR_MESSAGE',
  SAVE_LS_DOC_SEARCH_FIELDS: 'SAVE_LS_DOC_SEARCH_FIELDS',
  SAVE_LS_PROGRESS: 'SAVE_LS_PROGRESS',
  SAVE_LS_SEARCH_FIELDS: 'SAVE_LS_SEARCH_FIELDS',
  SELECT_LS_REVISION: 'SELECT_LS_REVISION',
  SHOULD_SEARCH_LEGAL_MEMOS: 'SHOULD_SEARCH_LEGAL_MEMOS',
  STORE_DUPLICATE_CHECK_RESULT: 'STORE_DUPLICATE_CHECK_RESULT',
  STORE_DUPLICATE_LS_REQUEST: 'STORE_DUPLICATE_LS_REQUEST',
  STORE_HIGHLIGHTED_LS_REQUESTS: 'STORE_HIGHLIGHTED_LS_REQUESTS',
  STORE_LS_REQUEST_HISTORY: 'STORE_LS_REQUEST_HISTORY',
  STORE_LS_REQUEST_STATUS_APPROVALS: 'STORE_LS_REQUEST_STATUS_APPROVALS',
  STORE_LS_REQUESTS: 'STORE_LS_REQUESTS',
  STORE_PAGINATION_NEXT: 'STORE_PAGINATION_NEXT',
  STORE_PAGINATION_PREV: 'STORE_PAGINATION_PREV',
  STORE_SEARCH_TERMS: 'STORE_SEARCH_TERMS',
  STORE_SEARCH_RESULT_COUNT: 'STORE_SEARCH_RESULT_COUNT',
  STORE_SINGLE_LS: 'STORE_SINGLE_LS',
  STORE_TARGET_LS_REQUEST: 'STORE_TARGET_LS_REQUEST',
  UPDATE_TARGET_LS_REQUEST_STATUS: 'UPDATE_TARGET_LS_REQUEST_STATUS',
  UPDATE_TARGET_LS_REQUEST: 'UPDATE_TARGET_LS_REQUEST',
  UPDATE_NEW_STATUS_CHANGE: 'UPDATE_NEW_STATUS_CHANGE',
  CREATE_NEW_LS_TASK: 'CREATE_NEW_LS_TASK',
  CREATE_SUB_TASK_UPDATE: 'CREATE_SUB_TASK_UPDATE',
  UPDATE_LS_TASK: 'UPDATE_LS_TASK',
  DELETE_FULL_TASK: 'DELETE_FULL_TASK',
  DELETE_SINGLE_TASK_UPDATE: 'DELETE_SINGLE_TASK_UPDATE',
  STORE_NEW_TASK: 'STORE_NEW_TASK',
  STORE_NEW_SUB_TASK_UPDATE: 'STORE_NEW_SUB_TASK_UPDATE',
  DELETE_FULL_TASK_IN_STORE: 'DELETE_FULL_TASK_IN_STORE',
  DELETE_SINGLE_TASK__UPDATE_IN_STORE: 'DELETE_SINGLE_TASK__UPDATE_IN_STORE',
  STORE_EDITED_TASK: 'STORE_EDITED_TASK',
  CREATE_NEW_COMMENT: 'CREATE_NEW_COMMENT',
  UPDATE_COMMENT: 'UPDATE_COMMENT',
  DELETE_COMMENT: 'DELETE_COMMENT',
  STORE_NEW_COMMENT: 'STORE_NEW_COMMENT',
  STORE_UPDATED_COMMENT: 'STORE_UPDATED_COMMENT',
  REMOVE_COMMENT_FROM_STATE: 'REMOVE_COMMENT_FROM_STATE',
  SEND_DOCUMENTS_TO_CM: 'SEND_DOCUMENTS_TO_CM',
};

// Action for get the ls request number from front-end form
export const checkDuplicate = requestNum => {
  return { type: lsRequestActions.CHECK_DUPLICATE, requestNum };
};

// Action for checking loading process
export const checkLsIsLoading = status => {
  return { type: lsRequestActions.CHECK_LS_IS_LOADING, status };
};

// Action for clearing the ls requests
export const clearLsRequestArray = () => {
  return { type: lsRequestActions.CLEAR_LS_REQUEST_ARRAY };
};

// Action for detecting current target(clicked) ls request
export const clickedLsRequest = (ls, actionType) => {
  return { type: lsRequestActions.CLICKED_LS_REQUEST, ls, actionType };
};

// Action for notifying that the new ls request creation has been created
export const createNewLsRequestStatus = status => {
  return { type: lsRequestActions.CREATE_NEW_LS_REQUEST_STATUS, status };
};

// Action for creating a new ls request
export const createNewLsRequest = newLs => {
  return { type: lsRequestActions.CREATE_NEW_LS_REQUEST, newLs };
};

export const deleteFile = (ls, id, field) => {
  return { type: lsRequestActions.DELETE_FILE, ls, id, field };
};

//Action for exporting all LS requests
export const exportLsRequest = () => {
  return { type: lsRequestActions.EXPORT_ALL_LS_REQUESTS };
};

export const exportingFullLS = bool => {
  return { type: lsRequestActions.EXPORTING, bool };
};

// Action for getting the bill history
export const getBillHistory = ls_number => {
  return { type: lsRequestActions.GET_BILL_HISTORY, ls_number };
};

export const getDuplicateLsRequest = ls => {
  return { type: lsRequestActions.GET_DUPLICATE_LS_REQUEST, ls };
};

export const getLsRequestHistory = ls_number => {
  return { type: lsRequestActions.GET_LS_REQUEST_HISTORY, ls_number };
};

// Action for getting the new created ls request number
export const getNewCreatedLsNumber = number => {
  return { type: lsRequestActions.GET_NEW_CREATED_LS_NUMBER, number };
};

export const isDuplicateLsLoading = status => {
  return { type: lsRequestActions.IS_DUPLICATE_LS_LOADING, status };
};

// Action triggered from View
export const loadLsRequests = (
  nextApi,
  sortedBy,
  filtered = { bool: false, url: '' },
  shouldReset = false
) => {
  return {
    type: lsRequestActions.LOAD_LS_REQUESTS,
    nextApi,
    sortedBy,
    filtered,
    shouldReset
  };
};

export const loadLsRequestStatusApprovalList = () => {
  return { type: lsRequestActions.LOAD_LS_REQUEST_STATUS_APPROVAL_LIST };
};

// Action for changing current status to new status

export const changeOldStatusToNewStatus = payloadObj => {
  return {
    type: lsRequestActions.UPDATE_NEW_STATUS_CHANGE,
    payloadObj,
  };
};

// Action for opening the ls request service popup window
export const openOrCloseLsRequestServicePopup = status => {
  return {
    type: lsRequestActions.OPEN_OR_CLOSE_LS_REQUEST_SERVICE_POPUP,
    status,
  };
};

export const activateLsRequest = ls_number => {
  return { type: lsRequestActions.REQUEST_ACTIVATION, ls_number };
};

// Action for saving the bill history
export const saveBillHistoryList = bills => {
  return { type: lsRequestActions.SAVE_ALL_HISTORY_LIST, bills };
};

// Action for saving the current clicked ls request
export const saveCurrentLsRequest = ls => {
  return { type: lsRequestActions.SAVE_CURRENT_LS_REQUEST, ls };
};

// Action for saving error message from backend after submit
export const saveErrorMessage = message => {
  return { type: lsRequestActions.SAVE_ERROR_MESSAGE, message };
};

//Save the progress of an LS
export const saveLSProgress = ls => {
  return { type: lsRequestActions.SAVE_LS_PROGRESS, ls };
};

export const selectLsRevision = (revision, index) => {
  return { type: lsRequestActions.SELECT_LS_REVISION, revision, index };
};

// Action for saving the duplicate checking result
export const storeDuplicateCheckResult = results => {
  return { type: lsRequestActions.STORE_DUPLICATE_CHECK_RESULT, results };
};

export const storeDuplicateLsRequest = request => {
  return { type: lsRequestActions.STORE_DUPLICATE_LS_REQUEST, request };
};

export const storeLsRequestHistory = (history = []) => {
  return { type: lsRequestActions.STORE_LS_REQUEST_HISTORY, history };
};

// Action triggered from Sagas
export const storeLsRequests = (
  lsRequests,
  prevApi,
  nextApi,
  fullCount,
  highlights,
  shouldReset = false,
  isLoading = false,
  invalidSearch = false,
) => {
  return {
    type: lsRequestActions.STORE_LS_REQUESTS,
    lsRequests,
    prevApi,
    nextApi,
    fullCount,
    highlights,
    shouldReset,
    isLoading,
    invalidSearch,
  };
};

export const storeSearchTerms = search => {
  return {
    type: lsRequestActions.STORE_SEARCH_TERMS,
    search
  }
}

export const storeHighlightedLsRequests = lsRequests => {
  return { type: lsRequestActions.STORE_HIGHLIGHTED_LS_REQUESTS, lsRequests }
}

export const storeLsRequestStatusApprovals = lsRequests => {
  return {
    type: lsRequestActions.STORE_LS_REQUEST_STATUS_APPROVALS,
    lsRequests,
  };
};

// Store nextApi and prevApi for pagination
export const storePaginationNext = nextApi => {
  return { type: lsRequestActions.STORE_PAGINATION_NEXT, nextApi };
};

export const storePaginationPrev = prevApi => {
  return { type: lsRequestActions.STORE_PAGINATION_PREV, prevApi };
};

//Action to store search result count
export const storeSearchResultCount = count => {
  return { type: lsRequestActions.STORE_SEARCH_RESULT_COUNT, count };
};

export const fetchOneLsr = (ls, callback) => {
  return { type: lsRequestActions.STORE_SINGLE_LS, ls, callback };
};

// Action for storing the target ls request filter by ls number
export const storeTargetLsRequest = target => {
  return { type: lsRequestActions.STORE_TARGET_LS_REQUEST, target };
};

// Action for checking whether update is successfully or not
export const updateTargetLsRequestStatus = status => {
  return { type: lsRequestActions.UPDATE_TARGET_LS_REQUEST_STATUS, status };
};

// Action for updating the target ls request
export const updateTargetLsRequest = ls => {
  // if (ls.division === 'Unassigned') ls.division = 'NONE';
  return { type: lsRequestActions.UPDATE_TARGET_LS_REQUEST, ls };
};

export const sendDocumentsToCM = ls => {
  return { type: lsRequestActions.SEND_DOCUMENTS_TO_CM, ls }
  // Action for saving search fields
}

export const saveDocSearchFields = fields => {
  return { type: lsRequestActions.SAVE_LS_DOC_SEARCH_FIELDS, fields };
};

export const saveSearchFields = fields => {
  return { type: lsRequestActions.SAVE_LS_SEARCH_FIELDS, fields };
};

export const saveLegalMemoSearch = shouldSearchLegalMemos => {
  return { type: lsRequestActions.SHOULD_SEARCH_LEGAL_MEMOS, shouldSearchLegalMemos }
}

// Action for creating a new Ls task:
export const createNewLsTask = (ls_request, taskData) => {
  return { type: lsRequestActions.CREATE_NEW_LS_TASK, ls_request, taskData };
};

// Action for a full update for LS task:
export const updateLsTask = taskData => {
  return { type: lsRequestActions.UPDATE_LS_TASK, taskData };
};

// Action for creating sub-task update for LS task:
export const createSubtaskUpdate = taskData => {
  return { type: lsRequestActions.CREATE_SUB_TASK_UPDATE, taskData };
};

// Action for deleting a full task:
export const deleteFullTaskAction = taskLabelObj => {
  return { type: lsRequestActions.DELETE_FULL_TASK, taskLabelObj };
};

// Action for deleting a single task update:
export const deleteSingleTaskUpdateAction = taskLabelObj => {
  return { type: lsRequestActions.DELETE_SINGLE_TASK_UPDATE, taskLabelObj };
};

// Action to store the new created task:
export const storeNewTasksResult = newTask => {
  return { type: lsRequestActions.STORE_NEW_TASK, newTask };
};

// Action to store the new sub-task update:
export const storeNewSubTasksUpdate = (subTaskUpdate, taskId) => {
  return { type: lsRequestActions.STORE_NEW_SUB_TASK_UPDATE, subTaskUpdate, taskId };
};

// Action to edit a task in the store:
export const storeEditedTask = editedTask => {
  return { type: lsRequestActions.STORE_EDITED_TASK, editedTask };
};

// Action to delete a full task from the store's state:
export const deleteFullTaskFromState = taskId => {
  return { type: lsRequestActions.DELETE_FULL_TASK_IN_STORE, taskId };
};

// Action to delete a full task from the store's state:
export const deleteSingleTaskUpdateFromState = taskData => {
  return {
    type: lsRequestActions.DELETE_SINGLE_TASK__UPDATE_IN_STORE,
    taskData,
  };
};

// Action for creating a comment:
export const createNewComment = (commentData) => ({
  type: lsRequestActions.CREATE_NEW_COMMENT,
  commentData,
});

// Action for updating a comment:
export const updateComment = (commentData) => ({
  type: lsRequestActions.UPDATE_COMMENT,
  commentData,
});

// Action for deleting a comment:
export const deleteComment = (commentId) => ({
  type: lsRequestActions.DELETE_COMMENT,
  commentId,
});

// Action for storing a new comment in the store:
export const storeNewComment = (newComment) => ({
  type: lsRequestActions.STORE_NEW_COMMENT,
  newComment,
});

// Action for storing an updated comment in the store:
export const storeUpdatedComment = (updatedComment) => ({
  type: lsRequestActions.STORE_UPDATED_COMMENT,
  updatedComment,
});

// Action for removing a comment from the store:
export const removeCommentFromState = (commentId) => ({
  type: lsRequestActions.REMOVE_COMMENT_FROM_STATE,
  commentId,
});